import { _axios as axios } from '@/plugins/axios.js'

function getInitialState() {
  return {
  }
}

export default {
  namespaced: true,
  state: getInitialState(),
  actions: {
  },
  mutations: {
  }
}
